import soloPhoto from '../images/profile-pic.jpg'
function Photo() {
    return(
        <div id="ctn-image">
            <img src={soloPhoto} alt="photo"></img>
            <p id="attribution"><em>Photo credit: &copy; 2024 ADL pro photo"</em></p>
            <div id="randomfact">I am a student at Ironhack 2024</div>
        </div>
    );
}

export default Photo;
